import common from "./common.json";

import countsCreateSchedule from "./counts/createSchedule.json";
import countsList from "./counts/list.json";
import countsProductSearchModal from "./counts/productSearchModal.json";
import countsStartCount from "./counts/startCount.json";

import stockChangeVendorModal from "./stock/changeVendorModal.json";
import stockLabelPrint from "./stock/labelPrint.json";
import stockNewPO from "./stock/newPO.json";
import stockOrdersTab from "./stock/ordersTab.json";
import stockPendingRestockTab from "./stock/pendingRestockTab.json";
import stockPoDetails from "./stock/poDetails.json";
import stockPoReceive from "./stock/poReceive.json";
import stockPoReceiveDetails from "./stock/poReceiveDetails.json";
import stockProductSearchModal from "./stock/productSearchModal.json";
import stockReceiveOrder from "./stock/receiveOrder.json";
import stockReceiveOrderDetails from "./stock/receiveOrderDetails.json";
import stockReceiveReturnForm from "./stock/receiveReturnForm.json";
import stockReturnForm from "./stock/returnForm.json";
import stockShell from "./stock/shell.json";
import stockTransferForm from "./stock/transferForm.json";
import stockTransfersTab from "./stock/transfersTab.json";
import stockVendorReceivedTab from "./stock/vendorReceivedTab.json";
import stockVendorTab from "./stock/vendorTab.json";

// One JSON per screen in the Inventory module. The key path mirrors the file path:
// inventory/common.json is `common.*`, inventory/counts/startCount.json is
// `counts.startCount.*`, inventory/stock/newPO.json is `stock.newPO.*`. Add a screen
// by dropping in its JSON and adding it here; src/i18n/index.ts stays untouched.
const inventory = {
  common,
  counts: {
    createSchedule: countsCreateSchedule,
    list: countsList,
    productSearchModal: countsProductSearchModal,
    startCount: countsStartCount,
  },
  stock: {
    changeVendorModal: stockChangeVendorModal,
    labelPrint: stockLabelPrint,
    newPO: stockNewPO,
    ordersTab: stockOrdersTab,
    pendingRestockTab: stockPendingRestockTab,
    poDetails: stockPoDetails,
    poReceive: stockPoReceive,
    poReceiveDetails: stockPoReceiveDetails,
    productSearchModal: stockProductSearchModal,
    receiveOrder: stockReceiveOrder,
    receiveOrderDetails: stockReceiveOrderDetails,
    receiveReturnForm: stockReceiveReturnForm,
    returnForm: stockReturnForm,
    shell: stockShell,
    transferForm: stockTransferForm,
    transfersTab: stockTransfersTab,
    vendorReceivedTab: stockVendorReceivedTab,
    vendorTab: stockVendorTab,
  },
};

export default inventory;
